<!--
 * @Descripttion: 
 * @Author: luoyang
 * @Date: 2021-11-29 17:19:57
 * @LastEditors: luoyang
 * @LastEditTime: 2021-11-30 15:20:45
-->
<template>
  <!-- 系统特色 -->
  <div class="system_features-mb">
    <div class="mobile-container">
      <h1 class="partH1" ref="HeaderTitle">系统特色</h1>
      <ul class="system_features_ul-mb" ref="ul">
        <li class="system_features_li-mb" v-for="(item,index) in systemFeatures.part1" :key="index">
          <div class="features_index">{{item.index}}</div>
          <p>{{item.info}}</p>
          <img :src="item.img">
        </li>
      </ul>
    </div>
  </div>

</template>

<script>
export default {
  props: {
    systemFeatures: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.system_features-mb {
  .partH1 {
    width: 1720px;
    height: 180px;
    line-height: 180px;
    font-size: 156px;
    font-weight: 600;
    padding: 284px 0 329px; //padding-bottom=174+155
    box-sizing: content-box;
    color: #000000;
  }
  .system_features_ul-mb {
    .system_features_li-mb {
      position: relative;
      min-height: 1164px;
      .features_index {
        font-size: 356px;
        font-family: bannerEn;
        font-weight: 500;
        color: #e4e4e4;
        position: absolute;
        top: -186px;
        z-index: -1;
      }
      p {
        font-size: 100px;
        font-weight: 600;
        color: #000000;
        margin-bottom: 64px;
      }
      img {
        width: 1636px;
        height: 711px;
      }
    }
  }
}
</style>